import { createTransform } from 'redux-persist';

const EXPIRY_DURATION = 20 * 60 * 1000; // 20 minutes in milliseconds

interface CompanyRegistrationPersistedState {
  claimedCompanyData: any;
  userRegisteredCompanyData: any;
  mappedBranchesData: any[];
  _persistedAt?: number;
}

export const expireTransform = createTransform<CompanyRegistrationPersistedState, CompanyRegistrationPersistedState>(
  // 1️⃣ Called when saving to localStorage
  (inboundState) => {
    return {
      ...inboundState,
      _persistedAt: Date.now(),
    };
  },

  // 2️⃣ Called when loading from localStorage
  (outboundState) => {
    const persistedAt = outboundState?._persistedAt;
    const now = Date.now();

    if (!persistedAt || now - persistedAt > EXPIRY_DURATION) {
      // ⛔ Expired: reset to initial state
      return {
        claimedCompanyData: null,
        userRegisteredCompanyData: null,
        mappedBranchesData: [],
      };
    }

    const { _persistedAt, ...cleanState } = outboundState;
    return cleanState;
  },

  // 3️⃣ Apply only to this slice
  { whitelist: ['companyRegistration'] }
);
